import { createReducer, on } from '@ngrx/store';
import { coursesActions } from '../actions/courses.actions';
import { Course } from '../models';
import { PaginationParams } from '../types';

export interface CoursesState {
    loaded: boolean | null;
    loading: boolean | null;
    courses: Course[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: CoursesState = {
    loaded: null,
    loading: null,
    courses: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const coursesReducer = createReducer(
    initialState,
    on(coursesActions.getCourses, (state, { value }): CoursesState => ({
        ...state,
        loading: true,
        page: value.page,
        limit: value.limit,
        lastParams: value,
    })),
    on(coursesActions.getCoursesSuccess, (state, { payload, total }): CoursesState => ({
        ...state,
        loaded: true,
        loading: false,
        courses: payload,
        total,
    })),
    on(coursesActions.getCoursesError, (state): CoursesState => ({
        ...state,
        loaded: false,
        loading: false,
    })),
    on(coursesActions.clear, (): CoursesState => ({ ...initialState })),
);
